import Swiper, { Navigation, Autoplay } from 'swiper';
import {swiperObserver} from "../../utils/swiper.utils.js";

const initNumbersSwiper = (scope = document) => {
  scope.querySelectorAll('.numbers-swiper-wr').forEach((el) => {
    let swiperEl = el.querySelector('.swiper');
    let nextEl = el.querySelector('.swiper-button-next');
    let prevEl = el.querySelector('.swiper-button-prev');

    if (!swiperEl || swiperEl.swiper) {
      return;
    }

    const wrapper = swiperEl.querySelector('.swiper-wrapper');
    if (!wrapper) {
      return;
    }

    const slideCount = wrapper.querySelectorAll(':scope > .swiper-slide').length;
    if (!slideCount) {
      return;
    }

    if (slideCount >= 3 && !el.hasAttribute('data-always-swiper')) {
      swiperEl.classList.add('is-more-3-cards');
      swiperEl.classList.add('no-swiper-type');
      wrapper.querySelectorAll(':scope > .swiper-slide').forEach((slide) => {
        slide.classList.toggle('is-small-type', Boolean(slide.querySelector('.numbers-card.small-type')));
      });
      return;
    }

    const originalHTML = wrapper.innerHTML;

    function markSingleSlides() {
      wrapper.querySelectorAll('.swiper-slide').forEach((slide) => {
        const count = slide.querySelectorAll('.numbers-card').length;
        slide.classList.toggle('swiper-slide--single', count === 1);
      });
    }

    function splitForMobile() {
      wrapper.innerHTML = originalHTML;
      const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
      slides.forEach((slide) => {
        const cards = Array.from(slide.querySelectorAll('.numbers-card'));
        if (cards.length > 1) {
          for (let i = cards.length - 1; i >= 1; i--) {
            const newSlide = document.createElement('div');
            newSlide.className = 'swiper-slide';
            newSlide.appendChild(cards[i]);
            slide.insertAdjacentElement('afterend', newSlide);
          }
        }
      });
      markSingleSlides();
    }

    function buildSwiper() {
      const isNumbersRow = el.hasAttribute('data-always-swiper');

      return new Swiper(swiperEl, {
        modules: [Navigation, Autoplay],
        observer: true,
        observeParents: true,
        spaceBetween: 16,
        slidesPerView: 1,
        threshold: 10,
        navigation: nextEl && prevEl ? { nextEl, prevEl } : undefined,
        breakpoints: isNumbersRow ? {
          453: {
            spaceBetween: 20,
            slidesPerView: 1.5,
          },
          768: {
            spaceBetween: 20,
            slidesPerView: 2,
          },
          851: {
            spaceBetween: 22,
            slidesPerView: 3,
          },
          1024: {
            spaceBetween: 24,
            slidesPerView: 4,
          },
        } : {
          320: {
            spaceBetween: 20,
            slidesPerView: 1,
          },
          767: {
            spaceBetween: 20,
            slidesPerView: 1,
          },
          961: {
            spaceBetween: 22,
            slidesPerView: 2,
          },
          1023: {
            spaceBetween: 24,
            slidesPerView: 3,
          },
        },
        autoplay: slideCount > 1 ? {
          delay: 4000,
          disableOnInteraction: false,
          pauseOnMouseEnter: window.innerWidth >= 1033,
        } : false,
      });
    }

    if (window.innerWidth < 768) {
      splitForMobile();
    } else {
      markSingleSlides();
    }

    let swiper = buildSwiper();
    let observer = swiperObserver(swiper);

    let wasMobile = window.innerWidth < 768;

    window.addEventListener('resize', () => {
      const isMobile = window.innerWidth < 768;
      if (isMobile === wasMobile) return;
      wasMobile = isMobile;

      observer?.disconnect();
      swiper.destroy(true, true);

      if (isMobile) {
        splitForMobile();
      } else {
        wrapper.innerHTML = originalHTML;
        markSingleSlides();
      }

      swiper = buildSwiper();
      observer = swiperObserver(swiper);
    });
  });
};

initNumbersSwiper();
window.initNumbersSwiper = initNumbersSwiper;
